module.exports = __webpack_public_path__ + "static/media/circle.716403ba.svg";